module.exports = __webpack_public_path__ + "img/durchf-min.128ae932.jpg";